import React from "react";
import style from "./custom-heading.module.css";

const HeadingSecondary = ({ className, children, id, styles }) => {
  return (
    <h2
      className={`${style.heading} ${style.headingSecondary} ${className}`}
      style={{ ...styles }}
      id={id}
    >
      {children}
    </h2>
  );
};

export default HeadingSecondary;
